export const handleColumnReorder = (oldIndex: number, newIndex: number, originalArray: any[]) => {
  const movedItem = originalArray.find((item, index) => index === oldIndex)
  const remainingItems = originalArray.filter((item, index) => index !== oldIndex)

  const reorderedItems = [...remainingItems.slice(0, newIndex), movedItem, ...remainingItems.slice(newIndex)]

  return reorderedItems
}
